export const BASIC_EDITOR_TOOLBAR_EVENT = 'iptv-basic-editor-toolbar';
export const BASIC_EDITOR_FILTER_STATE_EVENT = 'iptv-basic-editor-filter-state';

export type BasicEditorToolbarCommand =
  | 'expand-groups'
  | 'collapse-groups'
  | 'filter-duplicates'
  | 'filter-clear'
  | 'hide-hidden-channels'
  | 'open-column-picker'
  | 'check-streams';

export type BasicEditorToolbarDetail = {
  command: BasicEditorToolbarCommand;
  duplicateBy?: 'url' | 'name';
};

export type BasicEditorFilterStateDetail = {
  duplicatesActive: boolean;
};
